import { defineMessages } from "react-intl";

export default defineMessages({
  genetiivi: {
    id: "lukiokoulutus.genetiivi",
    defaultMessage: "Lukiokoulutuksen"
  },
  kebabCase: {
    id: "lukiokoulutus.kebabCase",
    defaultMessage: "lukiokoulutus"
  },
  kuvausteksti: {
    id: "lukiokoulutus.kuvausteksti",
    defaultMessage:
      "Lukiokoulutuksen järjestäminen edellyttää opetus ja kulttuuriministeriön myöntämää koulutuksen järjestämislupaa. Lupa voidaan myöntää hakemuksesta kunnalle, kuntayhtymälle, rekisteröidylle yhteisölle, säätiölle tai ulkomailla järjestettävää koulutusta varten. Koulutusta voidaan ministeriön päätöksellä järjestää myös valtion oppilaitoksessa. Tällä sivulla voit tarkastella koulutuksen järjestäjiä ja niiden järjestämislupia."
  },
  lyhytKuvaus: {
    id: "lukiokoulutus.lyhytKuvaus",
    defaultMessage:
      "Lukiokoulutuksen järjestäminen edellyttää opetus ja kulttuuriministeriön myöntämää koulutuksen järjestämislupaa. Lupa voidaan myöntää hakemuksesta kunnalle, kuntayhtymälle, rekisteröidylle yhteisölle, säätiölle tai ulkomailla järjestettävää koulutusta varten. Koulutusta voidaan ministeriön päätöksellä järjestää myös valtion oppilaitoksessa. Tällä sivulla voit tarkastella koulutuksen järjestäjiä ja niiden järjestämislupia."
  },
  paasivunOtsikko: {
    id: "lukiokoulutus.paasivunOtsikko",
    defaultMessage: "Lukiokoulutuksen järjestäjät"
  },
  esittelyteksti: {
    id: "lukiokoulutus.esittelyteksti",
    defaultMessage:
      "Tälle sivulle on koottu opetuksen järjestäjän järjestämisluvan perustiedot. Jos järjestäjällä on useampia voimassaolevia lukiokoulutuksen järjestämislupia, on niiden tiedot yhdistetty tälle sivulle. Järjestäjän luvat löytyvät alkuperäisinä kokonaisuudessaan Päätökset-välilehdeltä."
  },
  jarjestamislupa: {
    id: "lukiokoulutus.jarjestamislupa",
    defaultMessage: "Lukiokoulutuksen järjestämislupa"
  }
});
